<div class="content-wrapper">

  <div class="highlighted-section">
    <div class="container-fluid">

      <div class="row no-gutters">
        <div class="visualization-heading col-12">
          <div class="heading-info">
            <h3 class="heading-title"><i class="fa-solid fa-person-running" aria-hidden="true"></i> Running Intelligence</h3>
            <p class="heading-message">


              AI requests from <b>July 20, 2025</b> - <b>{{currentDateAndTime}}</b>
            </p>
          </div>

        </div>
      </div>

      <div class="highlighted-stats-visualization row no-gutters">
        <div class="stat-item col-md-6 col-lg-3" *ngFor="let item of values">
          <div class="stat-item-wrapper">
            <div class="row no-gutters">
              <div class="stat-icon col-2 col-md-3 col-lg-4 col-xl-3">
                <div class="ecom-frame ecom-frame--square">
                  <div class="ecom-frame__fill">
                    <mat-icon svgIcon="{{item.icon}}"></mat-icon>
                  </div>
                </div>
              </div>
              <div class="stat-info col-4 col-md-5 col-lg-12 col-xl-6 order-lg-2 order-xl-0">
                <span class="stat-reference">{{item.name}}</span>
                <span class="stat-value">{{item.value}}</span>
              </div>
              <div class="stat-trend col-4 col-md-4 col-lg-5 col-xl-3" [ngClass]="{'positive-trend': (item.trend > 0), 'negative-trend': (item.trend < 0)}">
                <div class="trend-mini-chart ecom-sparkline" role="img" [attr.aria-label]="item.name + ' trend'">
                  <span
                    class="ecom-sparkline__bar"
                    *ngFor="let h of item.sparkline"
                    [style.height.%]="h"
                    [style.backgroundColor]="item.sparkColor"
                  ></span>
                </div>
                <span class="trend-reference">{{ (item.trend > 0) ? '+' : '' }}{{ item.trend + '%' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="main-section">
    <div class="container-fluid">

      <div class="sales-visualization visualizations-section">
        <div class="row no-gutters">
          <div class="visualization-heading col-12">
            <div class="heading-info">
              <h4 class="heading-title">Requests &amp; daily IQ</h4>
            </div>
            <div class="heading-actions">
              <ul class="visualization-period-selector nav">
                <li class="period-item nav-item period-sync-item">
                  <button type="button" class="dashboard-sync-btn btn period-sync-action" (click)="onSyncDashboardData()" [disabled]="syncInProgress">
                    {{ syncInProgress ? 'Syncing...' : 'Sync' }}
                  </button>
                </li>
                <li class="period-item nav-item">
                  <a class="period-action nav-link active">This month</a>
                </li>
                <li class="period-item nav-item">
                  <a class="period-action nav-link">This week</a>
                </li>
                <li class="period-item nav-item">
                  <a class="period-action nav-link disabled" tabindex="-1" aria-disabled="true">Today</a>
                </li>
                <li class="period-item period-alt-item nav-item">
                  <a class="period-action nav-link">
                    <mat-icon class="calendar-icon" svgIcon="calendar"></mat-icon>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-3">
            <div class="visualization-stats row">
              <div class="stat-summary-wrapper col-12 col-md-6 col-lg-12">
                <div class="stat-summary requests-stats">
                  <span class="stat-reference">Requests</span>
                  <span class="stat-value">1,029</span>
                  <span class="stat-trend positive-trend">+5.2%</span>
                </div>
              </div>
              <div class="stat-summary-wrapper col-12 col-md-6 col-lg-12">
                <div class="stat-summary iq-stats">
                  <span class="stat-reference">Avg IQ (period)</span>
                  <span class="stat-value">105.1</span>
                  <span class="stat-trend positive-trend">+1.8%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-9">
            <div class="visualization-chart ecom-chart ecom-chart--dual-bars" role="img" aria-label="Request volume and average IQ by day">
              <div class="ecom-chart__legend">
                <span class="ecom-legend ecom-legend--requests">Requests</span>
                <span class="ecom-legend ecom-legend--iq">Avg IQ</span>
              </div>
              <div class="ecom-dual-cols">
                <div class="ecom-dual-col" *ngFor="let m of requestTrendDayLabels; let i = index">
                  <div class="ecom-dual-bars">
                    <span class="ecom-bar ecom-bar--primary" [style.height.%]="requestVolumeBars[i]"></span>
                    <span class="ecom-bar ecom-bar--secondary" [style.height.%]="dailyAvgIqBars[i]"></span>
                  </div>
                  <span class="ecom-month-label">{{ m }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="visualizations-section row">
        <div class="col-12 col-lg-7 col-xl-8">
          <div class="orders-visualization">
            <div class="row no-gutters">
              <div class="visualization-heading col-12">
                <div class="heading-info">
                  <h4 class="heading-title">Requests by category</h4>
                </div>
                <div class="heading-actions">
                  <div class="visualization-period-dropdown-selector" ngbDropdown placement="bottom-right">
                    <button class="period-dropdown-toggle btn" ngbDropdownToggle>
                      This year
                      <mat-icon class="toggle-icon" svgIcon="half-arrow-down"></mat-icon>
                    </button>
                    <div class="period-dropdown" ngbDropdownMenu>
                      <button class="period-option" ngbDropdownItem>2018</button>
                      <button class="period-option" ngbDropdownItem>2017</button>
                      <button class="period-option" ngbDropdownItem>2016</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="visualization-chart ecom-chart ecom-chart--grouped-bars" role="img" aria-label="Technology vs Politics request counts by month">
                  <div class="ecom-chart__legend">
                    <span class="ecom-legend ecom-legend--technology">Business</span>
                    <span class="ecom-legend ecom-legend--politics">Politics</span>
                  </div>
                  <div class="ecom-grouped-cols">
                    <div class="ecom-grouped-col" *ngFor="let m of categoryMonthLabels; let i = index">
                      <div class="ecom-grouped-bars">
                        <span class="ecom-bar ecom-bar--primary" [style.height.%]="categoryBarsBusiness[i]"></span>
                        <span class="ecom-bar ecom-bar--muted" [style.height.%]="categoryBarsPolitics[i]"></span>
                      </div>
                      <span class="ecom-month-label ecom-month-label--sm">{{ m }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-5 col-xl-4">
          <div class="full-report-banner banner-callout vertical-callout">
            <div class="callout-info">
              <h4 class="callout-title">Export request IQ report?</h4>
              <p class="callout-message">
                Download daily aggregates, category splits, and per-request IQ scores for offline review.
              </p>
            </div>
            <div class="callout-illustration-wrapper">
              <div class="ecom-frame ecom-frame--wide callout-illustration">
                <img
                  class="ecom-frame__img ecom-frame__img--contain"
                  src="/assets/illustrations/ecommerce-dashboard-full-report.svg"
                  alt="Request analytics export"
                  loading="lazy"
                />
              </div>
            </div>
            <button type="button" class="callout-btn btn">See reports</button>
          </div>
        </div>
      </div>

      <div class="latest-tickets-visualization visualizations-section ecom-live-history-daily-section">
        <div class="row no-gutters">
          <div class="visualization-heading col-12">
            <div class="heading-info">
              <h4 class="heading-title">Daily IQ &amp; category counts</h4>
              <p class="heading-message heading-message--compact">
                Live from your conversation history for the last month. User messages are counted as requests; categories use Politics, Business, Social, and Shopping.
              </p>
            </div>
            <div class="heading-actions">
              <ul class="visualization-period-selector nav">
                <li class="period-item nav-item period-sync-item">
                  <button type="button" class="dashboard-sync-btn btn period-sync-action" (click)="onSyncDashboardData()" [disabled]="syncInProgress">
                    {{ syncInProgress ? 'Syncing...' : 'Sync' }}
                  </button>
                </li>
                <li class="period-item nav-item">
                  <a class="period-action nav-link active">This month</a>
                </li>
                <li class="period-item nav-item">
                  <a class="period-action nav-link">This week</a>
                </li>
                <li class="period-item nav-item">
                  <a class="period-action nav-link disabled" tabindex="-1" aria-disabled="true">Today</a>
                </li>
                <li class="period-item period-alt-item nav-item">
                  <a class="period-action nav-link">
                    <mat-icon class="calendar-icon" svgIcon="calendar"></mat-icon>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="visualization-table col-12 table-responsive ecom-live-daily-table-wrap">
            <table class="daily-aggregates-table table table-borderless table-sm" mat-table matSort #dailyAggregatesSort="matSort" [dataSource]="dailyAggregatesTableDataSource">
              <ng-container matColumnDef="day">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Day </th>
                <td mat-cell *matCellDef="let element"> {{ formatAggregateDayCell(element.day) }} </td>
              </ng-container>
              <ng-container matColumnDef="request_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requests </th>
                <td mat-cell *matCellDef="let element"> {{element.request_count}} </td>
              </ng-container>
              <ng-container matColumnDef="avg_iq">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Avg IQ </th>
                <td mat-cell *matCellDef="let element"> {{ element.avg_iq | number:'1.1-1' }} </td>
              </ng-container>
              <ng-container matColumnDef="politics_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Politics </th>
                <td mat-cell *matCellDef="let element"> {{element.politics_count}} </td>
              </ng-container>
              <ng-container matColumnDef="business_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Business </th>
                <td mat-cell *matCellDef="let element"> {{element.business_count}} </td>
              </ng-container>
              <ng-container matColumnDef="social_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Social </th>
                <td mat-cell *matCellDef="let element"> {{element.social_count}} </td>
              </ng-container>
              <ng-container matColumnDef="consumer_shopping_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Shopping </th>
                <td mat-cell *matCellDef="let element"> {{element.consumer_shopping_count}} </td>
              </ng-container>
               <tr mat-header-row *matHeaderRowDef="dailyAggregatesTableDisplayedColumns"></tr>
               <tr mat-row *matRowDef="let row; columns: dailyAggregatesTableDisplayedColumns;"></tr>
            </table>
            <mat-paginator
              class="table-paginator"
              #dailyAggregatesPaginator
              [pageSizeOptions]="[5, 10, 25]"
              [pageSize]="5"
              [selectConfig]="{ panelClass: 'ecom-dashboard-paginator-select-panel' }"
            ></mat-paginator>
          </div>
        </div>
      </div>

      <div class="visualizations-section row">
        <div class="col-12 col-lg-6 col-xl-5">
          <div class="devices-visualization">
            <div class="row no-gutters">
              <div class="visualization-heading col-12">
                <div class="heading-info">
                  <h4 class="heading-title">Category mix</h4>
                </div>
                <div class="heading-actions">
                  <div class="visualization-period-dropdown-selector" ngbDropdown placement="bottom-right">
                    <button class="period-dropdown-toggle btn" ngbDropdownToggle>
                      This year
                      <mat-icon class="toggle-icon" svgIcon="half-arrow-down"></mat-icon>
                    </button>
                    <div class="period-dropdown" ngbDropdownMenu>
                      <button class="period-option" ngbDropdownItem>2018</button>
                      <button class="period-option" ngbDropdownItem>2017</button>
                      <button class="period-option" ngbDropdownItem>2016</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="visualization-chart-wrapper col-12 col-md-8 col-lg-6 col-xl-7">
                <div class="visualization-chart ecom-donut-wrap" role="img" aria-label="Share of requests by category">
                  <div class="ecom-donut" [style.background]="categoryDonutGradient"></div>
                  <ul class="ecom-donut-legend list-unstyled">
                    <li *ngFor="let s of requestCategorySlices"><span class="ecom-swatch" [style.backgroundColor]="s.color"></span>{{ s.label }} {{ s.pct }}%</li>
                  </ul>
                </div>
              </div>
              <div class="visualization-stats col-12 col-md-4 col-lg-6 col-xl-5">
                <div class="visualization-stat" [attr.stat-reference]="'technology'">
                  <div class="stat-icon">
                    <div class="ecom-frame ecom-frame--square">
                      <div class="ecom-frame__fill">
                        <mat-icon svgIcon="desktop"></mat-icon>
                      </div>
                    </div>
                  </div>
                  <div class="stat-info">
                    <span class="stat-reference">Business</span>
                    <span class="stat-value">{{ businessTotalDisplay }}</span>
                  </div>
                </div>
                <div class="visualization-stat" [attr.stat-reference]="'politics'">
                  <div class="stat-icon">
                    <div class="ecom-frame ecom-frame--square">
                      <div class="ecom-frame__fill">
                        <mat-icon svgIcon="tablet"></mat-icon>
                      </div>
                    </div>
                  </div>
                  <div class="stat-info">
                    <span class="stat-reference">Politics</span>
                    <span class="stat-value">{{ politicsTotalDisplay }}</span>
                  </div>
                </div>
                <div class="visualization-stat" [attr.stat-reference]="'childcare'">
                  <div class="stat-icon">
                    <div class="ecom-frame ecom-frame--square">
                      <div class="ecom-frame__fill">
                        <mat-icon svgIcon="mobile"></mat-icon>
                      </div>
                    </div>
                  </div>
                  <div class="stat-info">
                    <span class="stat-reference">Social</span>
                    <span class="stat-value">{{ socialTotalDisplay }}</span>
                  </div>
                </div>
                <div class="visualization-stat" [attr.stat-reference]="'shopping'">
                  <div class="stat-icon">
                    <div class="ecom-frame ecom-frame--square">
                      <div class="ecom-frame__fill">
                        <mat-icon svgIcon="watch"></mat-icon>
                      </div>
                    </div>
                  </div>
                  <div class="stat-info">
                    <span class="stat-reference">Shopping</span>
                    <span class="stat-value">{{ shoppingTotalDisplay }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6 col-xl-7">
          <div class="sales-distribution-visualization">
            <div class="row">
              <div class="visualization-heading col-12">
                <div class="heading-info">
                  <h4 class="heading-title">Requests &amp; IQ by region</h4>
                </div>
                <div class="heading-actions">
                  <div class="visualization-period-dropdown-selector" ngbDropdown placement="bottom-right">
                    <button class="period-dropdown-toggle btn" ngbDropdownToggle>
                      This year
                      <mat-icon class="toggle-icon" svgIcon="half-arrow-down"></mat-icon>
                    </button>
                    <div class="period-dropdown" ngbDropdownMenu>
                      <button class="period-option" ngbDropdownItem>2018</button>
                      <button class="period-option" ngbDropdownItem>2017</button>
                      <button class="period-option" ngbDropdownItem>2016</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="stats-highlights-outer col-12 col-lg-5 col-xl-4">
                <div class="row">
                  <div class="stat-highlight-wrapper col-12 col-md-6 col-lg-12">
                    <div class="stat-highlight requests-highlight-stats">
                      <span class="stat-value">{{ totalRequestsDisplay }}</span>
                      <span class="stat-reference">Total requests</span>
                    </div>
                  </div>
                  <div class="stat-highlight-wrapper col-12 col-md-6 col-lg-12">
                    <div class="stat-highlight iq-highlight-stats">
                      <span class="stat-value">{{ averageIqDisplay }}</span>
                      <span class="stat-reference">Avg IQ (all)</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="expanded-stats col-12 col-lg-7 col-xl-8">
                <div class="stat-details">
                  <div class="stat-info">
                    <span class="stat-reference">United States</span>
                    <span class="stat-value">1,240 req / IQ 108</span>
                  </div>
                  <ngb-progressbar class="stat-value-progressbar" [value]="85"></ngb-progressbar>
                </div>
                <div class="stat-details">
                  <div class="stat-info">
                    <span class="stat-reference">Brazil</span>
                    <span class="stat-value">890 req / IQ 101</span>
                  </div>
                  <ngb-progressbar class="stat-value-progressbar" [value]="70"></ngb-progressbar>
                </div>
                <div class="stat-details">
                  <div class="stat-info">
                    <span class="stat-reference">Australia</span>
                    <span class="stat-value">620 req / IQ 106</span>
                  </div>
                  <ngb-progressbar class="stat-value-progressbar" [value]="76"></ngb-progressbar>
                </div>
                <div class="stat-details">
                  <div class="stat-info">
                    <span class="stat-reference">Germany</span>
                    <span class="stat-value">510 req / IQ 112</span>
                  </div>
                  <ngb-progressbar class="stat-value-progressbar" [value]="65"></ngb-progressbar>
                </div>
                <div class="stat-details">
                  <div class="stat-info">
                    <span class="stat-reference">Uruguay</span>
                    <span class="stat-value">180 req / IQ 99</span>
                  </div>
                  <ngb-progressbar class="stat-value-progressbar" [value]="60"></ngb-progressbar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="visualizations-section row">
        <div class="top-selling-visualization-wrapper col-12 col-lg-7 col-xl-8">
          <div class="top-selling-visualization">
            <div class="row no-gutters">
              <div class="visualization-heading col-12">
                <div class="heading-info">
                  <h4 class="heading-title">Stacked requests by category</h4>
                </div>
              </div>
              <div class="col-12">
                <div class="visualization-chart ecom-chart ecom-chart--stacked" role="img" aria-label="Monthly requests stacked by Technology, Politics, ChildCare, Shopping">
                  <div class="ecom-stacked-cols">
                    <div class="ecom-stacked-col" *ngFor="let col of topCategoryStacks">
                      <div class="ecom-stacked-bars">
                        <span
                          *ngFor="let seg of col.segments"
                          class="ecom-stacked-seg"
                          [style.height.%]="seg.pct"
                          [style.backgroundColor]="seg.color"
                        ></span>
                      </div>
                      <span class="ecom-month-label ecom-month-label--sm">{{ col.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="top-visited-visualization-wrapper col-12 col-lg-5 col-xl-4">
          <div class="top-visited-visualization">
            <div class="row no-gutters">
              <div class="visualization-heading col-12">
                <div class="heading-info">
                  <h4 class="heading-title">Highest-IQ request topics</h4>
                </div>
                <div class="heading-actions">
                  <div class="visualization-period-dropdown-selector" ngbDropdown placement="bottom-right">
                    <button class="period-dropdown-toggle btn" ngbDropdownToggle>
                      This year
                      <mat-icon class="toggle-icon" svgIcon="half-arrow-down"></mat-icon>
                    </button>
                    <div class="period-dropdown" ngbDropdownMenu>
                      <button class="period-option" ngbDropdownItem>2018</button>
                      <button class="period-option" ngbDropdownItem>2017</button>
                      <button class="period-option" ngbDropdownItem>2016</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <ul class="products-list list-group list-group-flush">
                  <li class="product-item list-group-item">
                    <div class="product-image-wrapper">
                      <div class="ecom-frame ecom-frame--square product-thumb">
                        <img class="ecom-frame__img ecom-frame__img--cover" src="/assets/imgs/products/nike-1.png" alt="" loading="lazy" />
                      </div>
                    </div>
                    <span class="product-name">Formal logic tutoring — Technology</span>
                    <span class="product-stat-value positive-trend badge">IQ 124</span>
                  </li>
                  <li class="product-item list-group-item">
                    <div class="product-image-wrapper">
                      <div class="ecom-frame ecom-frame--square product-thumb">
                        <img class="ecom-frame__img ecom-frame__img--cover" src="/assets/imgs/products/iphone-x.jpg" alt="" loading="lazy" />
                      </div>
                    </div>
                    <span class="product-name">Legislative text diff — Politics</span>
                    <span class="product-stat-value positive-trend badge">IQ 119</span>
                  </li>
                  <li class="product-item list-group-item">
                    <div class="product-image-wrapper">
                      <div class="ecom-frame ecom-frame--square product-thumb">
                        <img class="ecom-frame__img ecom-frame__img--cover" src="/assets/imgs/products/bose.png" alt="" loading="lazy" />
                      </div>
                    </div>
                    <span class="product-name">Pediatric sleep schedule — ChildCare</span>
                    <span class="product-stat-value positive-trend badge">IQ 116</span>
                  </li>
                  <li class="product-item list-group-item">
                    <div class="product-image-wrapper">
                      <div class="ecom-frame ecom-frame--square product-thumb">
                        <img class="ecom-frame__img ecom-frame__img--cover" src="/assets/imgs/products/ipad-mini.jpg" alt="" loading="lazy" />
                      </div>
                    </div>
                    <span class="product-name">Warranty comparison matrix — Shopping</span>
                    <span class="product-stat-value positive-trend badge">IQ 115</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="visualizations-section row">
        <div class="col-12 col-lg-5 col-xl-4">
          <div class="latest-sales-visualization">
            <div class="row no-gutters">
              <div class="visualization-heading col-12">
                <div class="heading-info">
                  <h4 class="heading-title">Requests today</h4>
                </div>
              </div>
              <div class="col-12">
                <span class="stat-value">412</span>
                <span class="stat-previous-value">389 yesterday</span>
                <div class="latest-sales-chart ecom-sparkline ecom-sparkline--wide" role="img" aria-label="Requests today by hour">
                  <span
                    class="ecom-sparkline__bar ecom-sparkline__bar--narrow"
                    *ngFor="let h of requestsTodayBars"
                    [style.height.%]="h"
                  ></span>
                </div>
                <div class="highlighted-stats">
                  <h4 class="stats-reference">Top request paths</h4>
                  <ul class="stats-list list-unstyled">
                    <li class="stat-item">/requests/technology/review</li>
                    <li class="stat-item">/requests/politics/summary</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-7 col-xl-8">
          <div class="referrals-visualization">
            <div class="row no-gutters">
              <div class="visualization-heading col-12">
                <div class="heading-info">
                  <h4 class="heading-title">Category volume trend</h4>
                </div>
              </div>
              <div class="col-12">
                <div class="visualization-chart ecom-referral" role="img" aria-label="Monthly request volume by category">
                  <div class="ecom-referral-row" *ngFor="let label of categoryTrendLegend; let ri = index">
                    <span class="ecom-referral-label">{{ label }}</span>
                    <div class="ecom-referral-spark ecom-sparkline">
                      <span
                        class="ecom-sparkline__bar"
                        *ngFor="let h of categoryTrendSeries[ri]"
                        [style.height.%]="h"
                        [style.backgroundColor]="categoryTrendColors[ri]"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters" *ngIf="syncStatusMessage">
        <div class="col-12">
          <p class="heading-message heading-message--compact">{{ syncStatusMessage }}</p>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-12 dashboard-sync-bottom-wrap">
          <button type="button" class="dashboard-sync-btn btn" (click)="onSyncDashboardData()" [disabled]="syncInProgress">
            {{ syncInProgress ? 'Syncing...' : 'Sync' }}
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
